import React from "react";
import Forbidden from "./error/Forbidden";
import { Outlet } from "react-router-dom";
import { useAppSelector } from "../app/hooks";
import { UserService } from "../services";
import { Roles } from "../models";

interface CTEyeSecurityOutletProps extends React.PropsWithChildren {
  requireCtEyeDevices?: boolean;
}

export function CTEyeSecurityOutlet(props: Readonly<CTEyeSecurityOutletProps>) {
  const hasCtEyeDevices = useAppSelector((state) => state.auth.hasCtEyeDevices);
  const isStaff = UserService.isInAnyRole([Roles.admin, Roles.staff, Roles.dataAnalyst]);

  if (!isStaff && !hasCtEyeDevices) return <Forbidden />;

  return props.children ? <>{props.children}</> : <Outlet />;
}

export default CTEyeSecurityOutlet;





